module.exports = __webpack_public_path__ + "img/ze-charge.142e63b9.jpg";